import { ToastService } from '../../../../services/toast/toast.service';
import { ApiService } from 'src/app/services/api/api.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { SignupService } from 'src/app/services/signup/signup.service';
import Utils, { GetHelper } from 'src/app/helpers/utils';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { MaskPipe } from 'ngx-mask';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-signup-unified-company-complementary-bond',
  templateUrl: './signup-unified-company-complementary-bond.component.html',
  styleUrls: ['./signup-unified-company-complementary-bond.component.scss'],
})
export class SignupUnifiedCompanyComplementaryBondComponent
  implements OnInit, OnDestroy
{
  form = this.formBuilder.group({
    fund: [null, [Validators.required]],
    co_obligation: [false, []],
  });

  showForm = true;
  isAssignor = false;

  columns: TableColumn<CompanyBondResponse>[] = [];

  data: any[] = [];

  removeModal = false;
  addAnotherModal = false;

  loading = false;

  sending = false;

  event: any;

  needInviteFund = false;

  fundOptions: SelectItem[] = [];

  haveCoobligation = false;

  constructor(
    private formBuilder: FormBuilder,
    public signupService: SignupService,
    private api: ApiService,
    private toast: ToastService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private maskPipe: MaskPipe,
    private storageService: StorageService
  ) {}

  ngOnDestroy(): void {
    this.event.unsubscribe();
  }

  ngOnInit(): void {
    this.getFunds();
    this.getDataAndFillForm();
    this.isAssignor = this.router.url.includes('assignor');

    this.columns = [
      {
        name: 'Fundo de interesse',
        cell: (row) =>
          `${row.fund.name} | ${this.formatCnpj(row.fund.document)}`,
      },

      {
        name: !this.isAssignor ? '' : 'Possuí coobrigação',
        cell: (row) =>
          this.isAssignor ? '' : row.co_obligation ? 'Sim' : 'Não',
      },
    ];

    this.event = this.signupService.sendComplementaryCompanyData.subscribe(
      (value) => {
        if (value === 'complementaryBond') {
          // Verificar se é cedente ou prestador para pular a etapa de risco
          const isAssignor = this.router.url.includes('assignor');
          const isProvider = this.router.url.includes('provider');

          // Após "Fundos de interesse", vai para Admin (se fundo) ou Informações de risco.
          if (this.signupService.getIsFund()) {
            this.signupService.setComplementaryCompanyStep('complementaryRisk');
            this.signupService.changeCompanyStepEvent.emit('risk');
            return;
          }

          // Se for cedente ou prestador, pula a etapa de risco e vai direto para representantes
          if (isAssignor || isProvider) {
            this.signupService.setComplementaryCompanyStep(
              'complementaryRepresentatives'
            );
            this.signupService.changeCompanyStepEvent.emit('representatives');
          } else {
            this.signupService.setComplementaryCompanyStep('complementaryRisk');
            this.signupService.changeCompanyStepEvent.emit('risk');
          }
        }
      }
    );

    this.signupService.fillFormEvent.subscribe((value) => {
      this.form.patchValue({
        fund: this.fundOptions[0].value,
      });

      //   this.sendData();
    });
  }

  getDisabled() {
    if (this.addAnotherModal) {
      return this.form.invalid;
    }

    if (!this.showForm) {
      return false;
    }

    return this.form.invalid;
  }
  async triggerForm() {
    if (this.addAnotherModal) {
      await this.sendData();
    } else if (this.showForm) {
      await this.sendData();
      this.showForm = false;
    } else {
      if (this.data.length > 0) {
        this.addAnotherModal = true;
        this.setInvitedFund();
      } else {
        this.showForm = true;
        this.signupService.setCompanyFormStatus('complementaryBond', false);
      }
    }
  }

  setInvitedFund() {
    const user = this.authService.getUser();
    this.needInviteFund = false;

    const fundId = user.active_register.register.interest_fund;

    const hasInvitedFundId =
      user.active_register.register.invite &&
      user.active_register.register.invite.data.fund;

    if (hasInvitedFundId || fundId) {
      this.needInviteFund = true;

      const alreadyHaveFund = this.data.some((item) =>
        item.fund.id === hasInvitedFundId
          ? user.active_register.register.invite.data.fund
          : fundId
      );

      if (alreadyHaveFund) {
        this.needInviteFund = false;
        return;
      }

      this.form.patchValue({
        fund: hasInvitedFundId
          ? user.active_register.register.invite.data.fund
          : fundId,
      });
    }

    const newUserDataStorage = this.storageService.getNewUserData();

    if (newUserDataStorage && newUserDataStorage.fund) {
      const alreadyHaveFundFromStorage = this.data.some(
        (item) => item.fund.id === newUserDataStorage.fund
      );

      if (!alreadyHaveFundFromStorage) {
        this.form.patchValue({
          fund: newUserDataStorage.fund,
        });
      }
    }
  }

  handleCancel() {
    this.form.reset();
    this.form.controls.co_obligation.setValue(false);
    this.showForm = false;

    this.signupService.setCompanyFormStatus(
      'complementaryBond',
      this.data.length > 0
    );
  }

  /**
   * Obtém o register_uuid da URL (obrigatório, sem fallback)
   */
  private getRegisterUuid(): string | null {
    return this.route.snapshot.paramMap.get('id');
  }

  /**
   * Obtém os parâmetros de register_uuid para as requisições
   */
  private getRegisterParams(): any {
    const routeId = this.getRegisterUuid();
    if (!routeId) {
      console.error('Register UUID não encontrado na URL');
      return null;
    }
    return { register_uuid: routeId };
  }

  async removeInterest(index: number) {
    try {
      const finded = this.data[index];
      const params = this.getRegisterParams();

      if (!params) {
        this.toast.show('error', 'Erro', 'Register UUID não encontrado na URL');
        return;
      }

      const { message } = await this.api.delete({
        route: `api/registration/assignor-interest-fund/${finded.id}/`,
        params: params,
        token: true,
      });

      this.toast.show('info', 'Sucesso', message);

      this.getDataAndFillForm();
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', error.error.message);
    }
  }

  async getDataAndFillForm() {
    this.loading = true;
    try {
      const params = this.getRegisterParams();
      if (!params) {
        this.loading = false;
        return;
      }

      const response = await this.api.get<ApiResponse<CompanyBondResponse[]>>({
        route: 'api/registration/assignor-interest-fund/',
        params: params,
        token: true,
      });

      this.data = response.data || [];

      this.haveCoobligation = this.data.some((item) => item.co_obligation);

      this.showForm = this.data.length === 0;

      this.signupService.setCompanyFormStatus(
        'complementaryBond',
        this.data.length > 0
      );

      this.setInvitedFund();
      this.checkRepresentativeValidation();
    } catch (error) {
      console.log('error', error);
    }
    this.loading = false;
  }

  async checkRepresentativeValidation() {
    const { data } = await this.api.get<ApiResponse<RepresentativeResponse[]>>({
      route: 'api/registration/representative/',
      token: true,
    });

    const representatives_data = data;

    let blocked = false;

    if (this.haveCoobligation) {
      const isBlocked = representatives_data.some((item) => {
        const isGuarantor = item.info && item.info.representative.guarantor;
        const isSolidarity =
          item.info && item.info.representative.solidarity_debtor;
        const needPartner = !item.info.representative.spousal_consent;

        if ((isGuarantor || isSolidarity) && needPartner) {
          if (item.marital_id === null) {
            return true;
          }
        }

        return false;
      });

      blocked = isBlocked;
    }

    this.signupService.setCompanyFormStatus(
      'complementaryRepresentatives',
      blocked ?? representatives_data.length > 0
    );
  }

  async sendData() {
    this.sending = true;
    try {
      const params = this.getRegisterParams();
      if (!params) {
        this.toast.show('error', 'Erro', 'Register UUID não encontrado na URL');
        this.sending = false;
        return;
      }

      const valuesHelper = new GetHelper(this.form.value);

      const payload: any = {
        fund: valuesHelper.get('fund'),
        co_obligation: valuesHelper.get('co_obligation'),
      };

      const response = await this.api.post<ApiResponse<CompanyBondResponse>>({
        route: 'api/registration/assignor-interest-fund/',
        params: params,
        token: true,
        body: payload,
      });

      this.toast.show('info', 'Sucesso', response.message);

      this.form.reset();
      this.form.controls.co_obligation.setValue(false);

      if (this.addAnotherModal) {
        this.addAnotherModal = false;
      }

      this.getDataAndFillForm();
    } catch (error) {
      console.error(error);

      this.toast.show('error', 'Erro', error.error.message);
    }
    this.sending = false;
  }

  async getFunds() {
    try {
      const res = await this.api.get({
        route: 'api/registration/fund',
        token: false,
      });

      const filterRepeatedValues = Utils.filterRepeatedValues(res.funds, 'id');

      const funds = filterRepeatedValues.map((fund: any) => {
        return {
          label: `${fund.name} | ${this.formatCnpj(fund.document_number)}`,
          value: fund.id,
        };
      });

      this.fundOptions = funds;
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao carregar fundos de interesse');
    }
  }

  formatCnpj(value: string) {
    const newValue = Utils.formatDocumentForDisplay(value);

    return newValue;
  }

  handleCoObligationClick(eventValue: any, clickedValue: boolean) {
    const currentValue = this.form.controls.co_obligation.value;

    // Se clicar no mesmo valor que já está selecionado, alterna para o outro
    if (currentValue === clickedValue) {
      this.form.controls.co_obligation.setValue(!clickedValue);
    } else {
      // Caso contrário, apenas define o novo valor
      this.form.controls.co_obligation.setValue(clickedValue);
    }
  }

  handleCloseModal() {
    this.addAnotherModal = false;
    this.signupService.setCompanyFormStatus(
      'complementaryBond',
      this.data.length > 0
    );
    this.form.reset();
    this.form.controls.co_obligation.setValue(false);
  }
}
